import React from 'react';
import { cx } from 'linaria';
import { useDynamicSVGImport } from './useDynamicSVGImport';

export const SVG = ({ name, onCompleted, onError, ...rest }) => {
  const { error, loading, SvgIcon } = useDynamicSVGImport(name, {
    onCompleted,
    onError
  });
  if (error) {
    console.warn(`Problem loading svg named "${name}" - `, error);
    return null;
  }
  if (loading) {
    return '...';
  }
  if (SvgIcon) {
    return <SvgIcon className={cx('icon', name)} {...rest} />;
  }
  return null;
};
